import React from 'react'
import { graphql } from 'gatsby'
import Layout from '../components/layout'
import { Badge, Heading } from '@chakra-ui/react'
import RichContent from '../uielements/RichContent/richContent'
import { ContainerXl } from '../components/Containers/containers'
import { useTranslation } from 'react-i18next'
import { POST_SLUG } from '../lib/constants'
import PageGallery from './commonSections/gallery'
import Sharer from './commonSections/sharer'
import PageHeader from '../components/PageHeader'

export function Head({ data: { post } }) {
    const { i18n, t } = useTranslation()
    return (
        <>
            <title>{post.title} | {t('seo-title-suffix')}</title>
            <meta property="og:url" content={`${process.env.GATSBY_SITE_URL}/${POST_SLUG}/${post.slug}`} />
            <meta property="og:type" content="article" />
            <meta property="og:title" content={post.title} />
            <meta property="og:description" content={post.metaDesc} />
            <meta property="og:image" content={post.featuredImage.url} />
            <meta property="og:locale" content={i18n.language} />
        </>
    )
}

const Post = ({ data: { post } }) => {
    const { i18n, t } = useTranslation()
    return (
        <Layout>
            <PageHeader title={post.title} subtitle={post?.published} curvyText={post?.hashTag} featImg={post?.featuredImage} />
            <ContainerXl mt={12} mb={12}>
                {post?.tags?.map((tag, i) => (
                    <Badge key={i} variant={'outline'} padding={2} m={1}>
                        {tag}
                    </Badge>
                ))}
            </ContainerXl>
            <ContainerXl mt={12} mb={20}>
                <Heading>{t('article-body-info')}</Heading>
                <RichContent body={post.body} locale={i18n.language} />
            </ContainerXl>
            <PageGallery gallery={post?.gallery} />
            <Sharer post={post} />
        </Layout>
    )
}

export const query = graphql`
    query SinglePost($slug: String, $lang: String) {
        post: contentfulPosts(slug: { eq: $slug }, node_locale:{eq: $lang}) {
            id
            node_locale
            published(formatString: "D/MM/YYYY")
            slug
            title
            metaDesc
            hashTag
            attachments {
                file {
                    url
                    fileName
                    contentType
                }
                description
                title
                url
            }
            featuredImage {
                title
                description
                url
                gatsbyImageData(
                    placeholder: BLURRED
                    height: 1920
                    width: 1920
                    quality: 75
                    sizes: "(max-width: 576px) 768px, (max-width: 768px) 960px, (max-width: 960px) 1200px"
                    layout: FULL_WIDTH
                    breakpoints: [576, 768, 960, 1200, 1920]
                )
            }
            gallery {
                title
                description
                width
                height
                url
                gatsbyImageData(
                    placeholder: BLURRED
                    height: 1920
                    width: 1920
                    quality: 75
                    sizes: "(max-width: 576px) 768px, (max-width: 768px) 960px, (max-width: 960px) 1200px"
                    layout: FULL_WIDTH
                    breakpoints: [576, 768, 960, 1200, 1920]
                )
            }
            excerpt {
                raw
            }
            body {
                raw
                references {
                    ... on ContentfulEducationalLevels {
                        contentful_id
                        title
                        slug
                        internal {
                            type
                            content
                        }
                    }
                    ... on ContentfulPosts {
                        contentful_id
                        title
                        slug
                        internal {
                            type
                        }
                    }
                    ... on ContentfulPage {
                        contentful_id
                        title
                        slug
                        internal {
                            type
                        }
                    }
                    ... on ContentfulRegistrations {
                        contentful_id
                        title
                        slug
                        internal {
                            type
                        }
                    }
                    ... on ContentfulAsset {
                        contentful_id
                        mimeType
                        title
                        description
                        internal {
                            type
                        }
                        gatsbyImageData
                        url
                    }
                }
            }
            category
            tags
        }
    }
`

export default Post
